/* Grondyke advertorials · sticky offer bar. Slides in once the reader passes 60% of the
   viewport when data-gk-sticky-reveal="scroll"; always visible otherwise. Transform only,
   passive listener, honours prefers-reduced-motion (no transition). */
(function () {
  var bars = document.querySelectorAll('[data-gk-sticky]');
  if (!bars.length) return;
  Array.prototype.forEach.call(bars, function (bar) {
    if (bar.getAttribute('data-gk-sticky-reveal') !== 'scroll') { bar.classList.add('is-shown'); return; }
    var shown = false;
    var update = function () {
      var past = window.scrollY > window.innerHeight * 0.6;
      if (past !== shown) { shown = past; bar.classList.toggle('is-shown', shown); }
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  });
  // Publish the bar's real height so the footer reserve clears it at any width.
  var first = bars[0];
  var publish = function () {
    var h = Math.round(first.getBoundingClientRect().height);
    if (h) document.documentElement.style.setProperty('--gk-adv-sticky-h', h + 'px');
  };
  publish();
  if (window.ResizeObserver) new ResizeObserver(publish).observe(first);
  else window.addEventListener('resize', publish);
})();
